/**
 * The shared `QueryClient` defaults (plan §9.1).
 *
 * A factory rather than a singleton: the extension popup, the webapp and the
 * mobile app each build their own, and the one thing that legitimately differs
 * between them is `refetchOnWindowFocus`. It is a parameter here rather than a
 * branch inside the package — the package must not learn which runtime it is
 * in (plan §9.1, §9.3).
 */
import { QueryClient } from "@tanstack/react-query";
export function createNookQueryClient(options) {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30_000,
                refetchOnWindowFocus: options.refetchOnWindowFocus,
                gcTime: options.gcTime ?? 5 * 60_000,
                // Exponential with a ceiling, so a backend restart costs a few seconds
                // rather than a thundering herd.
                retry: 2,
                retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
            },
        },
    });
}
//# sourceMappingURL=query-client.js.map